export { FileDisplaySize, FileDisplayType } from './file-display.component';
